import { motion } from "framer-motion";

const STATUS_STYLES = {
    "Submitted": "bg-slate-100 text-slate-700",
    "Under Review": "bg-amber-100 text-amber-800",
    "Shortlisted": "bg-teal-100 text-teal-800",
    "Interview": "bg-secondary/40 text-secondary-foreground",
    "Selected": "bg-primary/15 text-primary",
    "Not Selected": "bg-accent/15 text-accent",
    "Open": "bg-amber-100 text-amber-800",
    "Resolved": "bg-primary/15 text-primary",
    "Approved": "bg-primary/15 text-primary",
    "In Progress": "bg-teal-100 text-teal-800",
    "Completed": "bg-primary/15 text-primary",
    "Rejected": "bg-accent/15 text-accent",
    "pending": "bg-amber-100 text-amber-800",
    "approved": "bg-primary/15 text-primary",
    "rejected": "bg-accent/15 text-accent",
    "paid": "bg-primary/15 text-primary",
    "created": "bg-slate-100 text-slate-700",
};

export function StatusBadge({ status }) {
    return (
        <span data-testid={`status-badge-${String(status).toLowerCase().replace(/\s/g, "-")}`}
            className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold ${STATUS_STYLES[status] || "bg-muted text-muted-foreground"}`}>
            {status}
        </span>
    );
}

export function SectionLabel({ children }) {
    return (
        <p className="font-mono text-xs font-medium uppercase tracking-[0.3em] text-accent" data-testid="section-label">{children}</p>
    );
}

export function FadeIn({ children, delay = 0, className = "" }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, delay, ease: "easeOut" }}
            className={className}>
            {children}
        </motion.div>
    );
}

export function Empty({ icon: Icon, title, hint }) {
    return (
        <div className="card-soft flex flex-col items-center gap-3 p-12 text-center" data-testid="empty-state">
            <span className="grid h-14 w-14 place-items-center rounded-full bg-muted"><Icon className="h-6 w-6 text-muted-foreground" /></span>
            <p className="font-display text-lg font-semibold">{title}</p>
            {hint && <p className="max-w-sm text-sm text-muted-foreground">{hint}</p>}
        </div>
    );
}

export const APPLICATION_STEPS = ["Submitted", "Under Review", "Shortlisted", "Interview", "Selected"];

export function ApplicationPipeline({ status }) {
    const rejected = status === "Not Selected";
    const currentIdx = APPLICATION_STEPS.indexOf(status);
    return (
        <div className="flex flex-wrap items-center gap-1" data-testid="application-pipeline">
            {APPLICATION_STEPS.map((s, i) => (
                <div key={s} className="flex items-center gap-1">
                    <span className={`rounded-full px-2.5 py-1 text-[11px] font-medium ${
                        rejected && i === currentIdx ? "bg-accent/15 text-accent"
                        : !rejected && i <= currentIdx ? "bg-primary text-white"
                        : "bg-muted text-muted-foreground"}`}>
                        {s}
                    </span>
                    {i < APPLICATION_STEPS.length - 1 && <span className="text-muted-foreground/50">→</span>}
                </div>
            ))}
            {rejected && (
                <>
                    <span className="text-muted-foreground/50">→</span>
                    <span className="rounded-full bg-accent px-2.5 py-1 text-[11px] font-medium text-white">Not Selected</span>
                </>
            )}
        </div>
    );
}
